import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  { q: "Como funcionam os pacotes de 64h e 96h?", a: "64h = até 2 dias por semana (16h semanais). 96h = até 3 dias por semana (24h semanais). Ambos têm validade de 30 dias. As horas são debitadas automaticamente conforme você reserva, e você acompanha o saldo no Portal do Cliente." },
  { q: "O que acontece se eu não usar todas as horas do pacote?", a: "As horas não utilizadas expiram após 30 dias. Recomendamos planejar o uso semanal: 16h/semana para o pacote 64h e 24h/semana para o 96h." },
  { q: "Posso fazer day use sem contratar pacote?", a: "Sim! O Day Use é R$ 40 por dia inteiro, sem fidelidade. Pague apenas quando precisar usar o coworking." },
  { q: "Quais salas e ambientes vocês oferecem?", a: "Temos 5 Escritórios Executivos (salas privativas para até 2 pessoas), 1 Consultório completo com lavabo, salas de reunião para 5 e 8 pessoas, e estações de coworking compartilhadas." },
  { q: "O que está incluso em todos os planos?", a: "Recepção, sala de espera, gestão de correspondências, impressora multifuncional, café/cappuccino/água, limpeza diária e apoio operacional." },
  { q: "Preciso ter fidelidade no plano?", a: "Não. Todos os planos podem ser cancelados com aviso prévio de 30 dias, sem multa. Pacotes de horas têm validade de 30 dias." },
  { q: "Posso visitar o espaço antes de contratar?", a: "Sim! Agende um tour gratuito pelo WhatsApp ou pelo formulário. Mostramos toda a estrutura sem compromisso." },
  { q: "Como funciona o Escritório Virtual?", a: "Endereço comercial em Piabetá/RJ por R$ 49/mês. Versão com endereço fiscal sai por R$ 79/mês — ideal para abrir empresa usando nosso endereço oficial." },
  { q: "Há estacionamento disponível?", a: "Sim, oferecemos estacionamento próprio gratuito para clientes." },
  { q: "Quais formas de pagamento são aceitas?", a: "PIX, boleto bancário e cartão de crédito. Pacotes mensais e contratos têm cobrança recorrente automática." },
  { q: "Posso reservar uma sala de reunião por hora?", a: "Sim. A partir de R$ 58/hora para a sala de 5 pessoas e R$ 78/hora para a de 8 pessoas. Reserve pelo Portal do Cliente." },
  { q: "Qual é o horário de funcionamento do VM Corporate?", a: "Funcionamos de segunda a sábado, em horário comercial. Caso haja necessidade de atendimento especial, consulte nossa equipe." },
  { q: "Vocês recebem correspondências?", a: "Sim, gestão de correspondências está inclusa em todos os planos e no Escritório Virtual. Notificamos via WhatsApp quando algo chega para você." },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid="faq-page" className="pb-24">
      <section className="pt-24 pb-12 bg-[#0A1128]">
        <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
          <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-semibold mb-4">Perguntas Frequentes</div>
          <h1 className="font-display text-5xl lg:text-6xl text-white font-light leading-tight">
            Tire suas <span className="italic text-[#D4AF37]">dúvidas</span>.
          </h1>
        </div>
      </section>

      <section className="bg-[#0A1128] pb-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 space-y-3">
          {FAQS.map((f, i) => (
            <div key={i} className="card-marketing overflow-hidden" data-testid={`faq-item-${i}`}>
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/[0.02]"
              >
                <span className="font-display text-white text-lg">{f.q}</span>
                <span className="w-8 h-8 rounded-full border border-[#D4AF37]/30 flex items-center justify-center flex-shrink-0 ml-4">
                  {open === i ? <Minus size={14} className="text-[#D4AF37]" /> : <Plus size={14} className="text-[#D4AF37]" />}
                </span>
              </button>
              {open === i && (
                <div className="px-6 pb-6 text-white/70 leading-relaxed">{f.a}</div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
